<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.tipoActivo}}</h5>
                    </b-col>
                    <!-- <b-col cols="6" class="text-left">
                        <select v-model="infoEditAct[0].tipo_activo" class="form-control">
                            <option value="0">{{ labels.select }}</option>
                            <option v-for="tipActiv in listaTypeAct" :key="tipActiv.id" :value="tipActiv.tipo_activo">{{ tipActiv.descripcion }}</option>
                        </select>
                    </b-col> -->
                    <b-col cols="6" class="text-left">
                        <div v-for="tipActiv in listaTypeAct" :key="tipActiv.id">
                            <h5 v-if="infoEditAct[0].tipo_activo == tipActiv.tipo_activo">{{tipActiv.descripcion}}</h5>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.proveedor}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <select v-model="infoEditAct[0].proveedor" class="form-control">
                            <option value="0">{{ labels.select }}</option>
                            <option v-for="tercero in listaTerceros" :key="tercero.id" :value="tercero.identificacion">{{ tercero.nombre }}</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.fechaCompra}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="date" v-model="infoEditAct[0].fecha_compra" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorCompra}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoEditAct[0].valor_compra" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.valorSalvamento}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <input type="number" v-model="infoEditAct[0].valor_salvamento" class="form-control">
                    </b-col>
                </b-row>
                <b-row class="" v-for="caracteristica in caractActivo" :key="caracteristica.id">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{caracteristica.descripcion}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <div v-for="crtByAct in listCrtByAct" :key="crtByAct.id">
                            <!-- {{ caracteristica.caracteristica }} - {{ crtByAct.caracteristica }} -->
                            <input type="text" v-if="caracteristica.caracteristica == crtByAct.caracteristica" :name="caracteristica.descripcion" v-model="crtByAct.valor" class="form-control inputCaract" :id="crtByAct.caracteristica">
                        </div>
                    </b-col>
                </b-row>
                <!-- <h5>{{ infoEditAct[0].activo }}</h5>
                <h5>{{ listCrtByAct.length }} | {{ caractActivo.length }}</h5> -->
                <b-row v-if="caractActivo.length != listCrtByAct.length">
                    <b-col cols="12" class="text-center">
                        <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="generaCampos">
                            <md-icon>refresh</md-icon>
                        </md-button>
                    </b-col>
                </b-row>
                <!-- <pre>{{ infoEditAct[0] }}</pre> -->
                <md-dialog-actions class="mt-2">
                    <b-col cols="8" class="text-left">
                        <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-primary" @click="editarActivo">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
        <InacticaItem :InactivaItem="deleteActivo" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"></InacticaItem>
    </div>
</template>

<script>
import TipoActivo from '../../services/TipoActivo'
import Tercero from '../../services/Tercero'
import TipoActivoCaracteristica from '../../services/TipoActivoCaracteristica'
import ActivoCaracteristica from '../../services/ActivoCaracteristica';
import Activos from '../../services/Activos'
import InacticaItem from '../utils/InacticaItem.vue';

export default {
    name : 'Editar',
    props:['modalEditar','infoEditAct'],
    components : {InacticaItem},
    data:() => ({
        listaTypeAct : [],
        listaTerceros : [],
        caractActivo : [],
        listCaractAct : {},
        listCrtByAct : [],
        deleteActivo : false,
        idActivo : null
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title: "Editar activo",
                    save : "Guardar",
                    close : "Cerrar",
                    delete : 'Eliminar',
                    select : "Seleccione...",
                    codigo : 'Código',
                    tipoActivo : 'Tipo activo',
                    proveedor : 'Proveedor',
                    fechaCompra : 'Fecha compra',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                }
            }else{
                return {
                    title: "Edit active",
                    save : "Save",
                    close : "Close",
                    select : "Select...",
                    delete : 'Delete',
                    codigo : 'Code',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    fechaCompra : 'Purchase date',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        editarActivo(){

            const inputs = document.querySelectorAll('.inputCaract')
            const listCaract = [];
            let objCaract = {}
            inputs.forEach(input => {
                objCaract = {
                    'codCaracteristica' : input.id,
                    'infoCaracterist' : input.name,
                    'caracteristica' : input.value,
                }
                listCaract.push(objCaract);
            });

            for (let key in objCaract) {
                // Verifica si el valor es vacío
                console.log(objCaract);
                // console.log(objCaract[key]);
                if (objCaract[key] === null || objCaract[key] === undefined || objCaract[key] === '') {
                    this.$toast.error('Caracteristica(s) pendiente(s) por diligenciar')
                    return
                }
            }

            const valForm = [
                this.infoEditAct[0].activo,
                this.infoEditAct[0].tipo_activo,
                this.infoEditAct[0].proveedor,
                this.infoEditAct[0].fecha_compra,
                this.infoEditAct[0].valor_compra,
                this.infoEditAct[0].valor_salvamento
            ]

            if(valForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                // console.log('Edita');
                let info = {
                    'id' : this.infoEditAct[0].id,
                    'codActivo' : this.infoEditAct[0].activo,
                    'tipo_activo' : this.infoEditAct[0].tipo_activo,
                    'proveedor' : this.infoEditAct[0].proveedor,
                    'fecha_compra' : this.infoEditAct[0].fecha_compra,
                    'valor_compra' : this.infoEditAct[0].valor_compra,
                    'valor_salvamento' : this.infoEditAct[0].valor_salvamento,
                    'idUser' : this.$store.state.userId,
                    'caract_activo' : listCaract
                }
                console.log(info);

                Activos.updateActivoById(info)
                .then((res) => {

                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()                    
                    }
                })
                .catch((error) => { console.log(error) })
            }
        },
        cierraModalDelet(){
            this.deleteActivo = false
        },
        eliminaRegistro(){
            this.idActivo = this.infoEditAct[0].id
            this.deleteActivo = true
        },
        confirmInactivate(){
            // console.log(this.idActivo);
            Activos.inactivateActivo(this.idActivo)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()
                
                }
            })
            .catch((err) => { console.log(err) })
        },
        generaCampos(){

            const info = {
                'codActivo' : this.infoEditAct[0].activo,
                'idUser' : this.$store.state.userId,
                'lstCrtTpAct' : this.caractActivo
            }
            // console.log(info);
            TipoActivoCaracteristica.generaCamposCaract(info)
            .then((res) => {
                // console.log(res.data);
                this.modalEditar = false
                this.$toast.success(res.data.message)
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message);
                }
            })

        }
    },
    mounted(){
        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo)
            this.listaTypeAct = res.data.listTipoActivo
        })
        .catch((err) => { console.log(err) })

        Tercero.getAllTercero()
        .then((res) => {
            // console.log(res.data.listTercero);
            this.listaTerceros = res.data.listTercero
        })
    },
    watch:{
        modalEditar(valNew){
            if(valNew){
                TipoActivoCaracteristica.getTipoActivoCaractByTipAct(this.infoEditAct[0].tipo_activo)
                .then((res) => {
                    // console.log(res.data.tipActCar);
                    this.caractActivo = res.data.tipActCar
                })
                .catch((err) => {console.log(err);})


                ActivoCaracteristica.getActivoCaracteristicaByActivo(this.infoEditAct[0].activo)
                .then((res) => {
                    // console.log(res.data.listActCrtByAct);
                    this.listCrtByAct = res.data.listActCrtByAct
                })
                .catch((err) => {console.log(err);})
            }
        }
    }
}
</script>

<style>
</style>